export const  FETCH_ORDER_LIST_REQUEST = "FETCH_ORDER_LIST_REQUEST";
export const  FETCH_ORDER_LIST_SUCCESS = "FETCH_ORDER_LIST_SUCCESS";
export const  FETCH_ORDER_LIST_FAILURE = "FETCH_ORDER_LIST_FAILURE";
export const FETCH_RECEIVEDGIFTS_SUCCESS = "FETCH_RECEIVEDGIFTS_SUCCESS"